import { css } from '@/styled-system/css';

export const uploadedAttachmentListStyles = css.raw({
  maxHeight: '110px',
  overflowY: 'auto',
  marginLeft: 'default',
  display: 'flex',
  flexDirection: 'column',
});

export const uploadedWrapperStyles = css.raw({
  position: 'relative',
  marginTop: 'xs',
  paddingBottom: 'default',
});

export const linearGradientStyles = css.raw({
  background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.80) 60%, #FFF 100%)',
  height: '25px',
  width: '100%',
  position: 'absolute',
  bottom: '0',
  left: '0',
});
